import styled from 'styled-components'
import { CircularProgress } from 'ui/components'

import { PageFace } from '../../pageFace'

export const Box = styled.div<{ $face?: PageFace; $noPadding?: boolean }>`
  overflow: visible;
  position: relative;
  flex: 1;
  padding: ${(p) => !p.$noPadding && (p.$face === PageFace.PRIMARY ? '10px 50px 34px 50px' : '20px 50px 34px 50px')};
`

export const Inner = styled.div<{ isPending?: boolean }>`
  display: ${(p) => (p.isPending ? 'none' : 'block')};
`

export const SpinnerBackground = styled.div`
  position: fixed;
  background: #ffffff8f;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

export const WrappedSpinner = styled(CircularProgress)`
  position: absolute;
  top: 40%;
  opacity: 0.7;
`
